import {
    FETCH_DATA_USERS_REQUEST,
    FETCH_DATA_USERS_SUCCESS,
    FETCH_DATA_USERS_FAILURE,
} from '../../actions/users/get-users-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const UsersReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_USERS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_USERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };
        case FETCH_DATA_USERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default UsersReducer;